import { Spinner } from "@anu-its/ts-react-components";

export const LoadingEmpty = () => {
  return (
    <div className="flex mx-auto justify-center w-full h-full bg-bottom bg-no-repeat bg-cover">
      <div className="flex grow flex-col justify-center items-center">
        <Spinner />
      </div>
    </div>
  );
};

export const LoadingOverlay = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50">
      <div>
        <Spinner />
      </div>
    </div>
  );
};
